<template>
  <div class="layout business-layout">
    <h1>OrganisationLayout</h1>
    <router-view />
    <div
      v-if="linkWithParams && shouldAnnouncementBeShown"
      class="announcement flex center-all SB-border bottom">
      <!-- TODO : announcements should be positioned on top of each other and multiple should be visible if needed. -->
      <a
        target="_blank"
        class="greedy flex center-all"
        @click="navigateToAnnouncement">
        <!-- eslint-disable vue/no-v-html  -->
        <p
          class="mr-1 black"
          v-html="announcements[0].title" />
        <p>{{ announcements[0].button }}</p>
        <SBIcon
          class="ml-1"
          :icon="SBIconList.ARROW"
          :color="SBColors.bluePrimary"
          :size="10"
          :rotate="270" />
      </a>
      <SBIcon
        class="no-shrink ml-1"
        :icon="SBIconList.CLOSE_THIN"
        :color="SBColors.blackPrimary"
        :size="10"
        :hover-size="50"
        :rotate="270"
        @click="hideAnnouncement(true)" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import '@/assets/css/modules/_merchant-dashboard.scss';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'OrganisationLayout',
  components: {
    SBIcon,
  },
  data() {
    const whatsappIcon = require('@/assets/img/SB-Images/whatsapp-business-app-icon.svg');
    return {
      SBIconList,
      SBColors,
      announcements: [
        // left as a refference for the upcoming announcements
        // TODO : should be refactored to be provided via backend
        // {
        //   title: '🤖 Automate your conversations with AI assistants. ',
        //   link: 'https://tally.so/r/mOPzO8',
        //   button: 'Request early access',
        //   key: 'feature:AIassistant:1',
        // },
        {
          title: `<img src="${whatsappIcon}" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px;" /><b>New: Connect your existing WhatsApp Business app and keep chats in sync between AI Number and WhatsApp.</b>`,
          link: 'https://tally.so/r/PddPk0',
          // action: 'AIAssistantsCreate',
          button: 'Connect now',
          key: 'feature:AIassistant:6',
        },
      ],
      showAnnouncementLocalStorage: localStorage.getItem('feature:AIassistant:6'),
      freeCreditsFeature: false,
    };
  },
  computed: {
    ...mapGetters({
      showAnnouncement: 'system/showAnnouncement',
      me: 'organisation/me',
      currentOrganisation: 'organisation/currentOrganisation',
      features: 'organisation/features',
    }),
    linkWithParams() {
      if (!this.announcements[0]) return null;
      return `${this.announcements[0].link}?email=${this.me.email}&name=${this.currentOrganisation.name}`;
    },
    shouldAnnouncementBeShown() {
      const result = localStorage.getItem('feature:AIassistant:6') !== 'false' && this.showAnnouncement; // && this.freeCreditsFeature
      return result;
    },
  },
  watch: {
    shouldAnnouncementBeShown: {
      handler() {
        if (!this.shouldAnnouncementBeShown) {
          this.hideAnnouncement();
        } else {
          this.showAnnouncementVuex();
        }
      },
      immediate: true,
    },
    features: {
      handler(newFeatures, oldFeatures) {
        // Log when features change
        const newFreeCredits = newFeatures && newFeatures.flags && newFeatures.flags.free_credits;

        // Update the reactive data property
        this.freeCreditsFeature = (newFreeCredits && localStorage.getItem('feature:AIassistant:6') !== 'false') || false;
        if (this.freeCreditsFeature) {
          this.showAnnouncementVuex();
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.showAnnouncementLocalStorage === 'false') {
      this.hideAnnouncement();
    }
    // Set initial value for freeCreditsFeature
    if (this.features && this.features.flags && this.features.flags.free_credits) {
      this.freeCreditsFeature = this.features.flags.free_credits;
    }
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions({
      hideAnnouncementVuex: 'system/hideAnnouncement',
      showAnnouncementVuex: 'system/showAnnouncement',
    }),
    hideAnnouncement(local = false) {
      this.hideAnnouncementVuex(local);
    },
    navigateToAnnouncement() {
      if (this.announcements[0].action === this.$route.name) {
        window.eventBus.$emit('create-assistant');
      } else if (this.announcements[0].action) {
        this.$router.push({ name: this.announcements[0].action });
      } else {
        window.open(this.linkWithParams, '_blank');
      }
    },
  },
};
</script>

<style lang="scss">
.announcement-space {
  margin-top: 50px !important;
}

.announcement {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 258px;
  width: calc(100% - 258px);
  height: 50px;
  background-image: linear-gradient(92deg, #fffff4, #fff7fd 31%, #f7ffff 67%, #fafffa 100%);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  a {
    height: 100%;
  }

  a:hover {
    text-decoration: none;
    ::v-deep .sb-icon .mask {
      background-color: #2470cb !important;
    }
  }
}
</style>
